import { useStoreListener } from '../../../../useStoreListener';
import type { RestartState } from '../../../../coordinators/restart/restartStore';
import { getRestartManager } from '../../../../coordinators/restart/restartManagerInstance';

/**
 * Thin subscription hook for restart-schedule state.
 * All domain logic lives in RestartManager — this hook only subscribes to its store.
 */
export function useRestartStatus(): RestartState & {
  scheduleReboot: (epochSec: number) => void;
  cancelSchedule: () => void;
  restartNow: (source?: 'prompt' | 'confirm' | 'schedule') => void;
} {
  const manager = getRestartManager();
  const state = useStoreListener<RestartState>(manager.getStore());
  return {
    ...state,
    scheduleReboot: (epochSec: number) => manager.scheduleReboot(epochSec),
    cancelSchedule: () => manager.cancelSchedule(),
    restartNow: (source?: 'prompt' | 'confirm' | 'schedule') => manager.restartNow(source),
  };
}
